import { EmailInterface } from '../Interfaces/EmailInterface'
import { StateInterface } from '../Interfaces/StateInterface'
import { ReducerBuilder } from './ReducerBuilder'

type StateType = StateInterface | {}
type PayloadType = EmailInterface

const INITIAL_STATE = {}

const reducer = ReducerBuilder.create<StateType, PayloadType>(INITIAL_STATE)
  .mapAction('SEND_ESTIMATE_EMAIL', (state: StateType, payload: EmailInterface) => payload)
  .mapAction('SEND_RECEIPT_EMAIL', (state: StateType, payload: EmailInterface) => payload)
  .mapAction('SEND_DELIVERY_NOTE_EMAIL', (state: StateType, payload: EmailInterface) => payload)
  .mapAction('SEND_INVOICE_EMAIL', (state: StateType, payload: EmailInterface) => payload)
  .build()

export default reducer
